export const platformFilterOptions = [
  { value: "android", label: "platform-filter-option-android" },
  { value: "ios", label: "platform-filter-option-ios" },
];
